export default __webpack_public_path__ + "static/media/calonge-logo-white.f49877b6.png";